import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {HelperService} from 'app/main/pages/edit-template/helper.service';
import {RoleDetail} from '../../../signing-page/signing-page.dto';
import {ForwardSignatureService} from './forward-signature.service';

@Component({
  selector: 'app-forward-signature',
  templateUrl: './forward-signature.component.html',
  styleUrl: './forward-signature.component.scss'
})
export class ForwardSignatureComponent implements OnInit {
  @Input() roleId: number;
  @Input() document_id: number;
  @Input() is_sender: number;
  @Input() roleDetail:RoleDetail;
  public forwardSignature: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
    private helperService: HelperService,
    public activeModal: NgbActiveModal,
    private forwardSignatureService:ForwardSignatureService
  ) { }
  public invitationThrough = [
    { id: 1, name: 'Email', value: 'email' },
    { id: 2, name: 'Email and SMS', value: 'email_and_sms' },
    { id: 3, name: 'SMS', value: 'sms' }
  ];
  public submitted: boolean = false;
  public forwardSignatureLoader: boolean = false;
  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.forwardSignature = this.formBuilder.group({
      recipient: this.formBuilder.group({
        firstname: ['', Validators.required],
        lastname: [''],
        email: ['', [Validators.required, Validators.email]],
        phone_no: [''],
        persnol_no: [''],
        address: [''],
        city: [''],
        zipcode: ['']
      }),
      invitation_type: ['email']
    })
  }

  onSubmit() {
    this.submitted = true;
    if (this.forwardSignature.invalid) {
      return;
    }
    this.submitted = false;
    this.forwardSignatureLoader = true;
    this.forwardSignatureService.forwardSignature(this.roleId, this.document_id, this.newRole()).subscribe(
      {
        next: () => {
          window.location.reload();
        },
        error: (error) => {
          this.globalService.toastrError(error);
          this.forwardSignatureLoader = false;
          this.submitted = false;
        }
      }
    )
  }

  /**
   * Get form value behalf on key
   * @param key 
   * @returns Form value
   */
  getFilteredForm(key: string){
    const formData = {...this.forwardSignature.value};
    if(formData?.recipient?.phone_no){
      formData.recipient.phone_no = formData?.recipient?.phone_no?.e164Number;
    }
    return key ? formData[key] : formData;
  }


  newRole() {
    const newRole = this.formBuilder.group({
      document_id: this.document_id,
      role_name: [`Recipient 1`],
      role_color: this.globalService.generateRandomColor(),
      sender_as_role: [this.roleDetail.sender_as_role],
      recipient_id: [null],
      organization_id: [null],
      invitation_type: [this.roleDetail.invitation_type],
      invitation_order: [this.roleDetail.invitation_order],
      authentication_type: [this.roleDetail.authentication_type],
      authentication_required: [this.roleDetail.authentication_required],
      confirmation_type: [this.roleDetail.confirmation_type],
      signature_confirmation: [this.roleDetail.signature_confirmation],
      personfields: this.formBuilder.array(this.helperService.getPersonfields([], this.getFilteredForm('recipient'), false, false)),
      orgfields: this.formBuilder.array(this.helperService.getOrgfields([], {}, false, false)),
      recipient: this.getFilteredForm('recipient'),
      organization: null
    });
    return newRole.value;
  }
}
